import React, { useEffect, useMemo, useRef, useState } from "react";
import { useUserId } from "../UserIdContext";
import { buildAuthenticatedUrl, createApiClient } from "../lib/apiClient";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:3220";
const API = `${API_BASE}/api`;
const TC_DEFAULT = 1500;
const IVA = 0.21;
const api = createApiClient({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

const EXTRA_STYLES = `
.facturacion{
  --bg:#050c13;
  --panel:rgba(13,25,36,.68);
  --stroke:#143044;
  --text:#eaf3ff;
  --muted:#7f97b7;
  --primary:#0FB872;
  --accent:#65f9a1;
  --danger:#ff5a5a;
  --shadow: 0 18px 55px rgba(0,0,0,.45);
  --radius:18px;
  --in:#eaf6ea;
  --out:#f3efe3;
}
.facturacion *{box-sizing:border-box}
.facturacion{
  margin:0;
  min-height: 100vh;
  background:
    radial-gradient(1100px 700px at 10% 10%, rgba(15,184,114,.15), transparent 55%),
    radial-gradient(900px 600px at 90% 20%, rgba(101,249,161,.10), transparent 60%),
    radial-gradient(900px 600px at 50% 95%, rgba(15,184,114,.08), transparent 65%),
    var(--bg);
  color:var(--text);
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial;
}
.facturacion .wrap{ max-width: 1200px; margin: 0 auto; padding: 18px; }
.facturacion .hero{ display:flex; align-items:flex-end; justify-content:space-between; gap:14px; flex-wrap:wrap; margin-bottom: 14px; }
.facturacion .title{ font-size: 26px; margin:0; }
.facturacion .sub{ margin:6px 0 0 0; color: var(--muted); font-size: 13px; }
.facturacion .card{
  background: linear-gradient(180deg, var(--panel), rgba(13,25,36,.55));
  border: 1px solid rgba(20,48,68,.75);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  overflow:hidden;
  position: relative;
}
.facturacion .card::before{
  content:"";
  position:absolute;
  inset:-2px;
  background: radial-gradient(600px 220px at 20% 0%, rgba(101,249,161,.18), transparent 60%),
              radial-gradient(600px 220px at 80% 0%, rgba(15,184,114,.12), transparent 60%);
  pointer-events:none;
}
.facturacion .cardInner{ position:relative; padding: 16px; }
.facturacion .grid{ display:grid; grid-template-columns: 1.2fr .8fr; gap: 12px; align-items:start; }
@media(max-width:980px){ .facturacion .grid{ grid-template-columns: 1fr; } }
.facturacion .formGrid{ display:grid; grid-template-columns: 1fr 1fr; gap: 12px; }
@media(max-width:720px){ .facturacion .formGrid{ grid-template-columns: 1fr; } }
.facturacion .field{ display:grid; gap:7px; }
.facturacion .label{ font-size: 12px; color: var(--muted); }
.facturacion .input{
  width:100%;
  padding: 11px 12px;
  border-radius: 12px;
  border: 1px solid rgba(20,48,68,.9);
  background: rgba(6,12,18,.55);
  color: var(--text);
  outline:none;
  transition: .15s;
}
.facturacion .input:focus{ border-color: rgba(101,249,161,.55); box-shadow: 0 0 0 3px rgba(101,249,161,.12); }
.facturacion .btn{
  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid rgba(101,249,161,.35);
  background: linear-gradient(180deg, rgba(15,184,114,.18), rgba(6,12,18,.35));
  color: var(--text);
  cursor:pointer;
  font-weight: 700;
  letter-spacing:.2px;
  transition: .15s;
  box-shadow: 0 14px 40px rgba(0,0,0,.25);
}
.facturacion .btn:hover{ transform: translateY(-1px); border-color: rgba(101,249,161,.6); }
.facturacion .btn:disabled{ opacity:.55; cursor:not-allowed; transform:none; }
.facturacion .pill{
  display:inline-flex; align-items:center; gap:8px;
  padding: 10px 12px; border-radius: 999px;
  border: 1px solid rgba(20,48,68,.85);
  background: rgba(6,12,18,.35);
  color: var(--muted); font-size: 12px;
}
.facturacion .msgOk{ color: var(--accent); font-weight: 600; }
.facturacion .msgErr{ color: var(--danger); font-weight: 600; }
.facturacion .autocomplete{ position:relative; }
.facturacion .autocompleteList{
  position:absolute;
  top: calc(100% + 8px);
  left:0;
  right:0;
  z-index:15;
  display:grid;
  gap:8px;
  max-height:260px;
  overflow:auto;
  padding:10px;
  border-radius:14px;
  border: 1px solid rgba(20,48,68,.85);
  background: rgba(6,12,18,.96);
  box-shadow: 0 18px 45px rgba(0,0,0,.35);
}
.facturacion .autocompleteEmpty{
  padding: 2px 0;
  color: var(--muted);
  font-size: 12px;
}
.facturacion .autocompleteItem{
  width:100%;
  padding: 10px 12px;
  border-radius:12px;
  border: 1px solid rgba(20,48,68,.85);
  background: rgba(13,25,36,.78);
  color: var(--text);
  text-align:left;
  cursor:pointer;
  transition: .15s;
}
.facturacion .autocompleteItem:hover{
  border-color: rgba(101,249,161,.45);
  background: rgba(16,33,45,.92);
}
.facturacion .autocompleteName{
  display:block;
  font-weight:700;
}
.facturacion .autocompleteMeta{
  display:block;
  margin-top:3px;
  color: var(--muted);
  font-size:12px;
}
.facturacion .selectedHint{
  color: var(--muted);
  font-size:12px;
}

.facturacion .tableWrap{ margin-top: 14px; }
.facturacion .h3{ margin: 0 0 10px 0; font-size: 14px; color: var(--muted); font-weight:700; }
.facturacion .t{
  width:100%;
  border-collapse: collapse;
  overflow:hidden;
  border-radius: 14px;
  border:1px solid rgba(20,48,68,.75);
}
.facturacion .t th, .facturacion .t td{
  padding: 9px 10px;
  border-bottom: 1px solid rgba(250, 250, 250, 0.55);
  font-size: 13px;
}
.facturacion .t th{
  text-align:left;
  background: rgba(6,12,18,.45);
  color: var(--muted);
}
.facturacion .inRow td{ background: rgba(234,246,234,.08); color: #ffffff}
.facturacion .outRow td{ background: rgba(243,239,227,.08); color: #ffffff }
.facturacion .right{
  display:grid;
  gap: 10px;
}
.facturacion .kpi{
  border:1px solid rgba(20,48,68,.75);
  background: rgba(6,12,18,.35);
  border-radius: 14px;
  padding: 12px;
}
.facturacion .kpi .k{ color: var(--muted); font-size: 12px; }
.facturacion .kpi .v{ font-size: 18px; font-weight: 800; margin-top: 4px; color: #ffffff }
.facturacion .kpi .s{ font-size: 12px; color: var(--muted); margin-top: 3px; }
`;

function parseYYYYMMDD(s) {
  const [y, m, d] = (s || "").split("-").map(Number);
  if (!y || !m || !d) return null;
  const dt = new Date(y, m - 1, d);
  dt.setHours(0, 0, 0, 0);
  return dt;
}
function toDateOnly(d) {
  const x = new Date(d);
  if (Number.isNaN(x.getTime())) return null;
  x.setHours(0, 0, 0, 0);
  return x;
}
function fmtISO(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}
function rangoMesPorCierre(cierre) {
  const inicio = new Date(cierre);
  inicio.setMonth(inicio.getMonth() - 1);
  inicio.setDate(inicio.getDate() + 1);
  inicio.setHours(0, 0, 0, 0);

  const fin = new Date(cierre);
  fin.setHours(0, 0, 0, 0);
  return { inicio, cierre: fin };
}
function money(n) {
  const v = Number(n || 0);
  return v.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
function daysDiff(a, b) {
  return Math.round((a.getTime() - b.getTime()) / 86400000);
}
function canSearchClientQuery(value = "") {
  const query = String(value || "").trim();
  if (!query) return false;
  const digits = query.replace(/\D/g, "");
  return query.length >= 2 || digits.length >= 1;
}

export default function Facturacion() {
  const { deposito } = useUserId();
  const depositoActual = deposito || "binder1";

  const [cliente, setCliente] = useState("NESTLE");
  const [clienteSel, setClienteSel] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [buscandoCliente, setBuscandoCliente] = useState(false);
  const [clienteOpen, setClienteOpen] = useState(false);
  const [fechaCierre, setFechaCierre] = useState(() => fmtISO(new Date()));
  const [usdIn, setUsdIn] = useState("100");
  const [usdEstadia, setUsdEstadia] = useState("0.32");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [msgType, setMsgType] = useState("ok");

  const [previewIng, setPreviewIng] = useState([]);
  const [previewEgr, setPreviewEgr] = useState([]);
  const clienteWrapRef = useRef(null);

  useEffect(() => {
    const onDocMouseDown = (event) => {
      if (!clienteWrapRef.current?.contains(event.target)) {
        setClienteOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocMouseDown);
    return () => document.removeEventListener("mousedown", onDocMouseDown);
  }, []);

  useEffect(() => {
    const q = String(cliente || "").trim();
    if (!clienteOpen || !canSearchClientQuery(q)) {
      setClientes([]);
      setBuscandoCliente(false);
      return;
    }

    let cancel = false;
    const timer = setTimeout(async () => {
      try {
        setBuscandoCliente(true);
        const { data } = await api.get("/api/clientes/buscar", {
          params: { q },
        });
        if (!cancel) {
          setClientes(Array.isArray(data) ? data : []);
        }
      } catch (err) {
        console.error("GET /api/clientes/buscar", err?.response || err);
        if (!cancel) {
          setClientes([]);
        }
      } finally {
        if (!cancel) {
          setBuscandoCliente(false);
        }
      }
    }, 250);

    return () => {
      cancel = true;
      clearTimeout(timer);
    };
  }, [cliente, clienteOpen]);

  const rango = useMemo(() => {
    const cierre = parseYYYYMMDD(fechaCierre);
    if (!cierre) return null;
    return rangoMesPorCierre(cierre);
  }, [fechaCierre]);

  const resumen = useMemo(() => {
    const cierre = parseYYYYMMDD(fechaCierre);
    if (!cierre) return null;

    // ingreso: suma(usdIn * TC)
    const ingresoARS = previewIng.reduce((acc) => acc + (Number(usdIn) * TC_DEFAULT), 0);

    // egreso: suma(usdEstadia * dias * posOut * TC)
    const almEgreso = previewEgr.reduce((acc, e) => {
      const ingresoRef = previewIng.find((i) => i.remito === e.remito || i.factura === e.factura);
      const fechaIngreso = ingresoRef?.fecha ? toDateOnly(ingresoRef.fecha) : null;
      const fechaEgreso = e?.fecha ? toDateOnly(e.fecha) : null;
      const dias = (fechaIngreso && fechaEgreso)
        ? Math.max(0, daysDiff(fechaEgreso, fechaIngreso) + 1)
        : 0;
      return acc + (Number(usdEstadia) * dias * Number(e.cantidad || 0) * TC_DEFAULT);
    }, 0);

    // almacenaje stock: hoja2 (min(30, cierre - ingreso +1) * cant * usdEstadia * TC)
    const almStock = previewIng.reduce((acc, i) => {
      const fechaIng = toDateOnly(i.fecha);
      const dias = fechaIng ? Math.min(30, Math.max(0, daysDiff(toDateOnly(cierre), fechaIng) + 1)) : 0;
      const estadiasTotales = dias * Number(i.cantidad || 0);
      return acc + (estadiasTotales * Number(usdEstadia) * TC_DEFAULT);
    }, 0);

    const subtotal = ingresoARS + almEgreso + almStock;
    const iva = subtotal * IVA;
    const total = subtotal + iva;

    return { ingresoARS, almEgreso, almStock, subtotal, iva, total };
  }, [previewIng, previewEgr, usdIn, usdEstadia, fechaCierre]);

  async function cargarPreview() {
    try {
      setLoading(true);
      setMsg("");
      setMsgType("ok");
      const clienteActivo = clienteSel || (clientes.length === 1 ? clientes[0] : null);
      const clienteNombre = String(clienteActivo?.nombreCliente || cliente || "").trim();
      if (!clienteNombre) throw new Error("Falta cliente");
      if (!rango) throw new Error("Fecha de cierre inválida");

      const params = new URLSearchParams();
      params.set("cliente", clienteNombre);
      params.set("cierre", fechaCierre);
      params.set("deposito", depositoActual);
      const qs = params.toString() ? `?${params.toString()}` : "";

      const [resIng, resEgr] = await Promise.all([
        api.get(`/api/ingresos${qs}`),
        api.get(`/api/egresos${qs}`),
      ]);

      const ingAll = Array.isArray(resIng?.data) ? resIng.data : [];
      const egrAll = Array.isArray(resEgr?.data) ? resEgr.data : [];

      const inicio = rango.inicio;
      const cierre = rango.cierre;

      const ing = (ingAll || [])
        .filter((i) => String(i.cliente || "").toUpperCase() === clienteNombre.toUpperCase())
        .filter((i) => {
          const f = toDateOnly(i.fecha);
          return f && f >= inicio && f <= cierre;
        })
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

      const egr = (egrAll || [])
        .filter((e) => String(e.cliente || "").toUpperCase() === clienteNombre.toUpperCase())
        .filter((e) => {
          const f = toDateOnly(e.fecha);
          return f && f >= inicio && f <= cierre;
        })
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

      setPreviewIng(ing);
      setPreviewEgr(egr);

      if (ing.length === 0) {
        setMsgType("err");
        setMsg(`No hay ingresos de ${clienteNombre} entre ${fmtISO(inicio)} y ${fmtISO(cierre)}`);
      } else {
        setMsgType("ok");
        setMsg(`OK. Preview: ${ing.length} ingresos, ${egr.length} egresos. TC default: ${TC_DEFAULT}`);
      }
    } catch (e) {
      setMsgType("err");
      setMsg(e.message);
      setPreviewIng([]);
      setPreviewEgr([]);
    } finally {
      setLoading(false);
    }
  }

  function exportarExcel() {
    const clienteActivo = clienteSel || (clientes.length === 1 ? clientes[0] : null);
    const clienteNombre = String(clienteActivo?.nombreCliente || cliente || "").trim();
    const url =
      `${API}/export/facturacion-mensual?cierre=${encodeURIComponent(fechaCierre)}` +
      `&cliente=${encodeURIComponent(clienteNombre)}` +
      `&deposito=${encodeURIComponent(depositoActual)}` +
      `&tcDefault=${TC_DEFAULT}` +
      `&usdEstadia=${encodeURIComponent(usdEstadia)}` +
      `&usdIn=${encodeURIComponent(usdIn)}`;
    window.open(buildAuthenticatedUrl(url), "_blank", "noopener,noreferrer");
  }

  function handleSelectCliente(clienteOption) {
    setClienteSel(clienteOption || null);
    setCliente(clienteOption?.nombreCliente || "");
    setClientes([]);
    setClienteOpen(false);
  }

  return (
    <div className="facturacion">
      <style>{EXTRA_STYLES}</style>

      <div className="wrap">
        <div className="hero">
          <div>
            <h2 className="title">Facturación mensual (Ingresos / Egresos)</h2>
          </div>

          {rango ? (
            <div className="pill">
              <span>Rango:</span>
              <b>{fmtISO(rango.inicio)}</b>
              <span>→</span>
              <b>{fmtISO(rango.cierre)}</b>
            </div>
          ) : null}
        </div>

        <div className="card">
          <div className="cardInner">
            <div className="grid">
              <div>
                <div className="formGrid">
                  <div className="field">
                    <div className="label">Cliente</div>
                    <div className="autocomplete" ref={clienteWrapRef}>
                      <input
                        className="input"
                        value={cliente}
                        placeholder="Buscar cliente por nombre, codigo o CUIT"
                        onChange={(e) => {
                          setCliente(e.target.value);
                          setClienteSel(null);
                          setClienteOpen(true);
                        }}
                        onFocus={() => setClienteOpen(true)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && clientes.length > 0) {
                            e.preventDefault();
                            handleSelectCliente(clientes[0]);
                          }
                        }}
                      />
                      {clienteSel?.nombreCliente ? (
                        <div className="selectedHint">
                          Cliente seleccionado: <b>{clienteSel.nombreCliente}</b>
                        </div>
                      ) : null}
                      {clienteOpen ? (
                        <div className="autocompleteList" onMouseDown={(e) => e.preventDefault()}>
                          {buscandoCliente ? (
                            <div className="autocompleteEmpty">Buscando...</div>
                          ) : null}
                          {!buscandoCliente && !canSearchClientQuery(cliente) ? (
                            <div className="autocompleteEmpty">Escribi al menos 2 letras o un codigo.</div>
                          ) : null}
                          {!buscandoCliente && canSearchClientQuery(cliente) && clientes.length === 0 ? (
                            <div className="autocompleteEmpty">Sin resultados</div>
                          ) : null}
                          {!buscandoCliente && clientes.map((c) => (
                            <button
                              key={c._id || `${c.nombreCliente}-${c.CUIT || ""}`}
                              type="button"
                              className="autocompleteItem"
                              onClick={() => handleSelectCliente(c)}
                            >
                              <span className="autocompleteName">{c.nombreCliente || c.codCliente || "Cliente"}</span>
                              <span className="autocompleteMeta">
                                {[c.codCliente, c.CUIT].filter(Boolean).join(" | ") || "Sin datos extra"}
                              </span>
                            </button>
                          ))}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="field">
                    <div className="label">Fecha de cierre (YYYY-MM-DD)</div>
                    <input className="input" value={fechaCierre} onChange={(e) => setFechaCierre(e.target.value)} />
                  </div>
                  <div className="field">
                    <div className="label">USD IN (precio por ingreso)</div>
                    <input className="input" value={usdIn} onChange={(e) => setUsdIn(e.target.value)} />
                  </div>
                  <div className="field">
                    <div className="label">USD estadía (por pallet / día)</div>
                    <input className="input" value={usdEstadia} onChange={(e) => setUsdEstadia(e.target.value)} />
                  </div>

                  <div className="field" style={{ alignItems: "end" }}>
                    <button className="btn" onClick={cargarPreview} disabled={loading}>
                      {loading ? "Cargando..." : "Buscar / Previsualizar"}
                    </button>
                    <button className="btn" onClick={exportarExcel} disabled={loading} style={{ marginTop: 10 }}>
                      Exportar Excel
                    </button>

                    {msg ? (
                      <div className={msgType === "ok" ? "msgOk" : "msgErr"} style={{ marginTop: 10 }}>
                        {msg}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="tableWrap">
                  <div className="h3">Ingresos</div>
                  <table className="t">
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Pos IN</th>
                        <th>Remito</th>
                        <th>USD IN</th>
                        <th>Ingresos (ARS)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {previewIng.map((i, idx) => (
                        <tr key={idx} className="inRow">
                          <td>{String(i.fecha).slice(0, 10)}</td>
                          <td>{i.cantidad}</td>
                          <td>{i.remito}</td>
                          <td>{money(usdIn)}</td>
                          <td>{money(Number(usdIn) * TC_DEFAULT)}</td>
                        </tr>
                      ))}
                      {previewIng.length === 0 ? (
                        <tr><td colSpan={5} style={{ color: "var(--muted)" }}>Sin datos</td></tr>
                      ) : null}
                    </tbody>
                  </table>
                </div>

                <div className="tableWrap">
                  <div className="h3">Egresos</div>
                  <table className="t">
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Pos OUT</th>
                        <th>FC/RTO</th>
                        <th>Días estadia</th>
                        <th>USD estadía</th>
                        <th>Almacenaje Egreso (ARS)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {previewEgr.map((e, idx) => {
                        const ingRef = previewIng.find((i) => i.remito === e.remito || i.factura === e.factura);
                        const fechaIngreso = ingRef?.fecha ? toDateOnly(ingRef.fecha) : null;
                        const fechaEgreso = e?.fecha ? toDateOnly(e.fecha) : null;
                        const dias = (fechaIngreso && fechaEgreso)
                          ? Math.max(0, daysDiff(fechaEgreso, fechaIngreso) + 1)
                          : 0;
                        const alm = Number(usdEstadia) * dias * Number(e.cantidad || 0) * TC_DEFAULT;

                        return (
                          <tr key={idx} className="outRow">
                            <td>{String(e.fecha).slice(0, 10)}</td>
                            <td>{e.cantidad}</td>
                            <td>{e.fcRto}</td>
                            <td>{dias}</td>
                            <td>{money(usdEstadia)}</td>
                            <td>{money(alm)}</td>
                          </tr>
                        );
                      })}
                      {previewEgr.length === 0 ? (
                        <tr><td colSpan={6} style={{ color: "var(--muted)" }}>Sin datos</td></tr>
                      ) : null}
                    </tbody>
                  </table>
                </div>

              </div>

              <div className="right">
                <div className="kpi">
                  <div className="k">INGRESO (ARS)</div>
                  <div className="v">{resumen ? money(resumen.ingresoARS) : "—"}</div>
                </div>
                <div className="kpi">
                  <div className="k">ALMACENAJE EGRESO (ARS)</div>
                  <div className="v">{resumen ? money(resumen.almEgreso) : "—"}</div>
                </div>
                <div className="kpi">
                  <div className="k">ALMACENAJE STOCK (ARS)</div>
                  <div className="v">{resumen ? money(resumen.almStock) : "—"}</div>
                </div>
                <div className="kpi">
                  <div className="k">SUBTOTAL (ARS)</div>
                  <div className="v">{resumen ? money(resumen.subtotal) : "—"}</div>
                </div>
                <div className="kpi">
                  <div className="k">IVA 21% (ARS)</div>
                  <div className="v">{resumen ? money(resumen.iva) : "—"}</div>
                </div>
                <div className="kpi">
                  <div className="k">TOTAL (ARS)</div>
                  <div className="v">{resumen ? money(resumen.total) : "—"}</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
